
import React, { useEffect, useRef, useState } from 'react';
import { Play, Pause } from 'lucide-react';

const HeroVideo = () => {
  const videoRef = useRef<HTMLDivElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('opacity-100', 'translate-y-0');
          entry.target.classList.remove('opacity-0', 'translate-y-10');
          setIsLoaded(true);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '100px'
    });

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);

  // Toggle play/pause state for the control button
  const togglePlayPause = () => {
    const iframe = document.querySelector('iframe');
    if (iframe) {
      const message = isPlaying ? 'pause' : 'play';
      iframe.contentWindow?.postMessage({ type: message }, '*');
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div ref={videoRef} className="opacity-0 translate-y-10 transition-all duration-1000 ease-out">
      <div className="relative max-w-4xl mx-auto">
        <div className="rounded-xl overflow-hidden shadow-2xl" style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
          {isLoaded && (
            <iframe 
              src="https://www.loom.com/embed/7fc7fe66a62c4ff09d60d3b39835addd?sid=900c711c-edc0-4787-843d-6941452244c3&hide_share=true&hideEmbedTopBar=true" 
              frameBorder="0" 
              loading="lazy"
              title="AskSpot Demo Video"
              allowFullScreen 
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
            />
          )}
          
          {/* Simple play/pause button overlay */}
          <button
            onClick={togglePlayPause}
            className="absolute bottom-4 right-4 bg-[#003a70]/70 hover:bg-[#003a70] text-white rounded-full p-2 transition-colors z-20"
            aria-label={isPlaying ? "Pause video" : "Play video"}
          >
            {isPlaying ? (
              <Pause size={20} />
            ) : (
              <Play size={20} />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeroVideo;
